import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function FreezeScrolling() {
    this.defaultAttrs({
        scrollingSelector: null,
    });

    this.after('initialize', function() {
        this.on('mouseover', {
            scrollingSelector: this.freezeScrolling,
        });

        this.on('mouseout', {
            scrollingSelector: this.defrostScrolling,
        });
    });

    // Disable scrolling this element while scrolling on selected inner element
    this.freezeScrolling = function() {
        this.$node.css('overflow', 'hidden');
    };

    // Re-enable scrolling when not scrolling on selected inner element
    this.defrostScrolling = function() {
        this.$node.css('overflow', '');
    };
}

export default defineComponent(FreezeScrolling);



// WEBPACK FOOTER //
// ./src/js/component_ui/freeze-scrolling.js